import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { delay, put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/LoggedInUserAdapter';
import LoggedInUser from '../../../models/interfaces/LoggedInUser';
import { waitBeforeFetch } from '../../../utils/FetchState';
import {
  fetchLoggedInUser,
  FetchLoggedInUserActionType,
  loggedInUserFetched,
  LoggedInUserFetchedPayload,
  loggedInUserFetchFailed,
} from '../../actions/authentication/fetchLoggedInUser';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* fetchLoggedInUserSaga({ payload }: FetchLoggedInUserActionType) {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  const { fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getLoggedInUser, token, {});
  const { loggedInUser: loggedInUserDto, companyPlaces, error } = response;
  if (!error) {
    const loggedInUser: LoggedInUser = fromDto(loggedInUserDto);
    const responsePayload: LoggedInUserFetchedPayload = {
      loggedInUser,
      companyPlaces,
      timestamp,
    };
    yield getProtectedResponse(ProtectedServerPlaceEvent.joinRoom, token, { loggedInUser: loggedInUserDto });
    const responseAction = loggedInUserFetched(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = loggedInUserFetchFailed({ timestamp });
    yield put(responseAction);
  }
}

export default function* watchFetchLoggedInUserSaga() {
  yield takeEvery(fetchLoggedInUser, fetchLoggedInUserSaga);
}
